module.exports = __webpack_public_path__ + "static/media/comment-profile.fw.ca9b9121.png";